const section = "#hero";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

gsap.to(`${section} :where(.text *, .circle)`, {
  y: 20,
  stagger: 0.01,
  scrollTrigger: {
    trigger: section,
    start: "top top",
    end: "bottom 20%",
    scrub: 1,
    ease: "power1.in",
  },
});
